<tam-dialog tid="duplicated_contact_dialog" class="duplicated-contact-dialog threaddetail-sidesheet-status"
    [opened]="opened" #dialogRef>
    <ng-template #title>
        <span class="dialog-title">View Duplicates</span>
        <smart-icon class="dialog-close dark" name="close" (click)="clickClose()"></smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="use-record">Use one of those records?</div>
        <div class="body-container body-1">
            <div *ngFor="let item of config; trackBy:trackByFn" class="item-container">
                <tam-duplicated-item [config]="item"></tam-duplicated-item>
            </div>
        </div>
    </ng-template>
</tam-dialog>